"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasDefinedProps = hasDefinedProps;
/**
 * Validates that a defined, non-null object has defined props
 * @param {object} object The object to perform the prop check on
 * @param {array} props The props to validate the existance of
 * @returns {boolean} A boolean value denoting if the object has defined props
 */
function hasDefinedProps(object, props) {
  return object && props.every(prop => prop in object);
}